import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

export var useActiveState = function useActiveState(initialState, options) {
  var _useState = useState(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = _toConsumableArray(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = _toConsumableArray(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = _toConsumableArray(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};